import { render, staticRenderFns } from "./BrandColorPicker.vue?vue&type=template&id=06f183d8&scoped=true&"
import script from "./BrandColorPicker.vue?vue&type=script&lang=js&"
export * from "./BrandColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./BrandColorPicker.vue?vue&type=style&index=0&id=06f183d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f183d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VColorPicker,VIcon,VMenu,VSpacer,VTextField})
